module.exports = __webpack_public_path__ + "img/wx.240f6819.svg";